import { render, staticRenderFns } from "./socios-table.vue?vue&type=template&id=2725f4f0&scoped=true"
import script from "./socios-table.vue?vue&type=script&lang=js"
export * from "./socios-table.vue?vue&type=script&lang=js"
import style0 from "./socios-table.vue?vue&type=style&index=0&id=2725f4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725f4f0",
  null
  
)

export default component.exports